import { apiDelete, apiGet, apiPost, apiPut, invalidate } from "./client";
import type { ApiConfig } from "./client";

const BASE = "/penalty-blocks";

export interface ListPenaltyBlocksOptions {
  /** Query params (e.g. `{ active: true }`). */
  params?: Record<string, unknown>;
  skipSwal?: boolean;
}

/** GET /penalty-blocks. */
export function listPenaltyBlocks<T = any[]>(options: ListPenaltyBlocksOptions = {}): Promise<T> {
  const config: ApiConfig = {};
  if (options.params) config.params = options.params;
  if (options.skipSwal) config.skipSwal = true;
  return apiGet<T>(BASE, Object.keys(config).length ? config : undefined);
}

export async function createPenaltyBlock<T = any>(payload: unknown): Promise<T> {
  const result = await apiPost<T>(BASE, payload);
  invalidate(BASE);
  return result;
}

export async function updatePenaltyBlock<T = any>(id: string, payload: unknown): Promise<T> {
  const result = await apiPut<T>(`${BASE}/${id}`, payload);
  invalidate(BASE);
  return result;
}

/** DELETE /penalty-blocks/:id (deactivates the block). */
export async function deactivatePenaltyBlock<T = any>(id: string): Promise<T> {
  const result = await apiDelete<T>(`${BASE}/${id}`);
  invalidate(BASE);
  return result;
}
